<template>
    <div>
        <table style="width: 90%; margin: 0 5%; margin-top: 20px;">
            <tr>
                <td style="height: 30px; width: 25%;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">入职类型：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.entry_type}}</el-col>
                    </el-row>
                </td>
                <td style="width: 25%;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">招聘方式：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.recruitment_method}}</el-col>
                    </el-row>
                </td>
                <td style="width: 25%;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">入职时间：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.induction_time}}</el-col>
                    </el-row>
                </td>
                <td style="width: 25%;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">工龄：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.working_age}}</el-col>
                    </el-row>
                </td>
            </tr>

            <tr>
                <td style="height: 30px;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">入职薪资：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.induction_salary}}<el-button plain size="mini"
                                style="margin-left: 10px;">薪资记录</el-button>
                        </el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">入职添加时间：
                        </el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.induction_date}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">离职添加时间：
                        </el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.quit_date}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">籍贯：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.native_place}}</el-col>
                    </el-row>
                </td>
            </tr>

            <tr>
                <td style="height: 30px;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">员工类别：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.staff_type}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">加入集团日期：
                        </el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.induction_time}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">所属部门：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.project_name}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">试用期：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.probation_period}}</el-col>
                    </el-row>
                </td>
            </tr>

            <tr>
                <td style="height: 30px;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">转正日期：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.formal_date}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">所在职位：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.post_name}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">薪酬等级：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.pay_grade}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">职级：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.rank}}</el-col>
                    </el-row>
                </td>
            </tr>

            <tr>
                <td style="height: 30px;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">上级职位：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.we_chat}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">上级名称：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.we_chat}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">是否兼职：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.is_part_time_job_title}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">项目经验表：</el-col>
                        <el-col :span="14" style="line-height: 30px;">
                            <el-button plain size="mini">项目经验表</el-button>
                        </el-col>
                    </el-row>
                </td>
            </tr>

            <tr>
                <td style="height: 30px;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">现薪酬：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.spare5}}</el-col>
                    </el-row>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        props: ["from"],
    }
</script>

<style scoped="scoped">
    >>>.el-button {
        border: 1px solid #006e48;
        color: #006e48;
    }

    >>>.el-button:hover {
        border: 1px solid #006e48;
        color: #006e48;
    }
</style>



// WEBPACK FOOTER //
// work.vue?34f64d3e